// B2B ↔ Xero reconciliation — STUB.
//
// Xero is the system of record for invoices + payments. The Subscriptions tab
// already has a live matcher (lib/subsXeroMatch.js → MoreeceSubsXeroStack). The
// equivalent AR-side Xero feed (ACCREC invoices + payments) is not wired yet, so
// this returns a neutral "not linked" verdict the drawer renders as a grey chip.
//
// To go live: stand up a b2b-xero-reconcile Lambda (mirror MoreeceSubsXeroStack)
// that pulls ACCREC invoices by invoice_ref/po_ref, then replace fetchB2BXeroMatch
// with a real fetch + cache. The drawer/UI contract below stays the same.

export function fetchB2BXeroMatch(/* invoice */) {
  // Shape mirrors subsXeroMatch: { status, varianceCents, xeroRef } | null
  return null; // not wired — caller treats null as "unlinked"
}

// status: 'matched' | 'variance' | 'missing' | 'unlinked'
export function xeroChip(match) {
  if (!match) return { label: 'Xero: not linked', bg: '#f4f4f5', fg: '#a1a1aa' };
  if (match.status === 'matched') return { label: 'Matches Xero', bg: '#dcfce7', fg: '#16a34a' };
  if (match.status === 'variance') return { label: 'Xero variance', bg: '#fef3c7', fg: '#d97706' };
  if (match.status === 'missing') return { label: 'Not in Xero', bg: '#fee2e2', fg: '#dc2626' };
  return { label: 'Xero: not linked', bg: '#f4f4f5', fg: '#a1a1aa' };
}
